/**
 * Created by quikr on 2/7/17.
 */

const constants = new (function () {
  this.payrollType = {
    Quikr: "Quikr",
    "Team Lease": "Team Lease",
    "Team Lease(GH)": "Team Lease(GH)",
    "Reality Redefined": "Reality Redefined",
    Yoma: "Yoma",
    QHMR: "QHMR",
    "HDFC Realty": "HDFC Realty",
    Hiree: "Hiree",
    Babajobs: "Babajobs",
    Zimber: "Zimber",
  };
  this.locationType = {
    Ahmedabad: "Ahmedabad",
    Bangalore: "Bangalore",
    Chandigarh: "Chandigarh",
    Chennai: "Chennai",
    Coimbatore: "Coimbatore",
    Delhi: "Delhi",
    Pune: "Pune",
    Dwarka: "Dwarka",
    Gurgaon: "Gurgaon",
    Hyderabad: "Hyderabad",
    Jaipur: "Jaipur",
    Kochi: "Kochi",
    Kolkata: "Kolkata",
    Lucknow: "Lucknow",
    Mumbai: "Mumbai",
    Mysore: "Mysore",
    "New Delhi": "New Delhi",
    Noida: "Noida",
    Rapur: "Raipur",
    Rajasthan: "Rajasthan",
    Surat: "Surat",
    Vadodara: "Vadodara",
    Vijaywada: "Vijaywada",
    Nagpur: "Nagpur",
    Indore: "Indore",
  };
  this.verticalType = {
    "Cars & Bikes": "Cars & Bikes",
    Core: "Core",
    Goods: "Goods",
    QHMR: "QHMR",
    "Other Verticals": "Other Verticals",
    Jobs: "Jobs",
    "New Jobs": "New Jobs",
    QuikrRealty: "QuikrRealty",
    "Real Estate": "Real Estate",
    Services: "Services",
  };
  this.offerType = {
    "Offer Made": "Offer Made",
    "Offer Rejected": "Offer Rejected",
    Joined: "Joined",
  };
  this.functionType = {
    "Ad Monetisation": "Ad Monetisation",
    Admin: "Admin",
    Analytics: "Analytics",
    "Finance and Accounts": "Finance and Accounts",
    "Human Resource": "Human Resource",
    IT: "IT",
    MGMT: "MGMT",
    Marketing: "Marketing",
    Operations: "Operations",
    Product: "Product",
    "Product Monetization": "Product Monetization",
    "Public Relations": "Public Relations",
    Sales: "Sales",
    "Sales Operations": "Sales Operations",
    Technology: "Technology",
    UED: "UED",
  };
  this.erpDepartmentType = {
    "Ad Sales": "Ad Sales",
    Admin: "Admin",
    Analytics: "Analytics",
    "Finance and Accounts": "Finance and Accounts",
    "Human Resource": "Human Resource",
    Legal: "Legal",
    Marketing: "Marketing",
    MGMT: "MGMT",
    Marketing: "Marketing",
    "Operations : Logistics": "Operations : Logistics",
    "Operations : Operations - Others": "Operations : Operations - Others",
    Product: "Product",
    "Public Relations": "Public Relations",
    "Sales : FOS": "Sales : FOS",
    "Sales : Sales - Others": "Sales : Sales - Others",
    "Sales : Telesales": "Sales : Telesales",
    "Sales Operations": "Sales Operations",
    Technology: "Technology",
    UED: "UED",
    Verticalization: "Verticalization",
  };

  this.subDepartmentType = {
    "1800 Miss Call": "1800 Miss Call",
    AD_Posting: "AD_Posting",
    Activation: "Activation",
    "Ad - Operations": "Ad - Operations",
    "Ad Monetisation": "Ad Monetisation",
    "Ad Sales": "Ad Sales",
    Admin: "Admin",
    Analytics: "Analytics",
    Android: "Android",
    "Android- Escrow": "Android- Escrow",
    "Application Development": "Application Development",
    Bike_Calling: "Bike_Calling",
    Bike_Procurement: "Bike_Procurement",
    Bike_Selling: "Bike_Selling",
    "Book Now": "Book Now",
    "Brand Marketing": "Brand Marketing",
    "Business Development": "Business Development",
    "Business Intelligence": "Business Intelligence",
    "Call Quality & Lead Inspection": "Call Quality & Lead Inspection",
    Caller: "Caller",
    "Car Inspection": "Car Inspection",
    "Car Verified Leads": "Car Verified Leads",
    Car_Services_Finances: "Car_Services_Finances",
    "Channel Partner": "Channel Partner",
    "Channel Partners": "Channel Partners",
    Chat: "Chat",
    "Collecting Information": "Collecting Information",
    Content: "Content",
    "Content & Research": "Content & Research",
    "Content Creation": "Content Creation",
    "Content Moderation": "Content Moderation",
    "Content Research": "Content Research",
    "Content Review": "Content Review",
    "Corporate Sales": "Corporate Sales",
    "Customer Operations": "Customer Operations",
    "Customer Service": "Customer Service",
    "Customer Support": "Customer Support",
    "Customer Support - TL": "Customer Support - TL",
    "Data Collection": "Data Collection",
    "Data Entry": "Data Entry",
    "Dealer Procurement Program (DPP)": "Dealer Procurement Program (DPP)",
    "Delivery Ops": "Delivery Ops",
    Design: "Design",
    "Digital Marketing": "Digital Marketing",
    "Digital Marketing - SEM": "Digital Marketing - SEM",
    "Digital Marketing - SEO": "Digital Marketing - SEO",
    "Direct Sales": "Direct Sales",
    Doorstep: "Doorstep",
    "Email Marketing": "Email Marketing",
    "Email Support": "Email Support",
    "Engagement Management": "Engagement Management",
    Escrow: "Escrow",
    "Executive Assistant": "Executive Assistant",
    Finance: "Finance",
    "Finance and Accounts": "Finance and Accounts",
    Goods: "Goods",
    "Google Adwords": "Google Adwords",
    Groups: "Groups",
    H2H: "H2H",
    HR: "HR",
    HomeVision: "HomeVision",
    Horizontal: "Horizontal",
    "Human Resource": "Human Resource",
    IRX: "IRX",
    IT: "IT",
    "IT Infra": "IT Infra",
    Implementation: "Implementation",
    "Inspection Calling": "Inspection Calling",
    "Jobs/Profile creation": "Jobs/Profile creation",
    "Jobs/Recruitment": "Jobs/Recruitment",
    "Lead Generation": "Lead Generation",
    "Lead generation ": "Lead generation ",
    "Listing Operations": "Listing Operations",
    Logistics: "Logistics",
    MGMT: "MGMT",
    MIS: "MIS",
    Management: "Management",
    "Market Research": "Market Research",
    Marketing: "Marketing",
    "Mobile Development": "Mobile Development",
    Monetization: "Monetization",
    "Monetization/Escrow": "Monetization/Escrow",
    OBD_Services: "OBD_Services",
    OMS: "OMS",
    "On-Demand Services": "On-Demand Services",
    Operations: "Operations",
    PKHD: "PKHD",
    PLV: "PLV",
    "PLV + Activation (Blended)": "PLV + Activation (Blended)",
    Payment: "Payment",
    "Premium Support- Inbound": "Premium Support- Inbound",
    "Premium Support- Outbound": "Premium Support- Outbound",
    Product: "Product",
    "Product Management": "Product Management",
    "Product Monetization": "Product Monetization",
    "Product Operations": "Product Operations",
    "Public Relations": "Public Relations",
    QA: "QA",
    "QA-CR": "QA-CR",
    Quality: "Quality",
    "Quality and Product Analytics": "Quality and Product Analytics",
    "Quikr X": "Quikr X",
    "Quikr X - TL": "Quikr X - TL",
    "Quikr.com": "Quikr.com",
    QuikrX: "QuikrX",
    Quikr_Stepni: "Quikr_Stepni",
    "RTO Services": "RTO Services",
    "Realty Redefined": "Realty Redefined",
    Recovery: "Recovery",
    "Recovery & Renewals": "Recovery & Renewals",
    Renewal: "Renewal",
    Replies: "Replies",
    "SE - PCS - Email": "SE - PCS - Email",
    "SE - PCS - Inbound": "SE - PCS - Inbound",
    "SE - PCS - Inbound + Email": "SE - PCS - Inbound + Email",
    "SE - PCS - Outbound": "SE - PCS - Outbound",
    "SE - PCS - Outbound - IR": "SE - PCS - Outbound - IR",
    "SE - PCS - Outbound - Listings": "SE - PCS - Outbound - Listings",
    "SE - PCS - Outbound - RM": "SE - PCS - Outbound - RM",
    "SE - PCS - Outbound - VL": "SE - PCS - Outbound - VL",
    "SE - PCS - Sales Audit": "SE - PCS - Sales Audit",
    "SE - PCS - Sales Helpdesk": "SE - PCS - Sales Helpdesk",
    "SE - Training": "SE - Training",
    SFM: "SFM",
    "SFM - Ad Posting": "SFM - Ad Posting",
    "SFM - Escalations": "SFM - Escalations",
    "SFM - RM": "SFM - RM",
    "SFM- Ad Posting": "SFM- Ad Posting",
    Sales: "Sales",
    "Sales Analytics": "Sales Analytics",
    "Sales Operations": "Sales Operations",
    "Sales Support": "Sales Support",
    "Sales-RE": "Sales-RE",
    Scheduling: "Scheduling",
    "Scheduling / Payment": "Scheduling / Payment",
    "Service Provider Operations": "Service Provider Operations",
    "Service Seeker Operations": "Service Seeker Operations",
    Services: "Services",
    "Social Marketing": "Social Marketing",
    "Social Media Support": "Social Media Support",
    Stylist: "Stylist",
    Technology: "Technology",
    Telesales: "Telesales",
    Trainer: "Trainer",
    UDAAN: "UDAAN",
    UED: "UED",
    "UED - Centralized Ideation": "UED - Centralized Ideation",
    "UED - Content": "UED - Content",
    "UED - Creative Marketing": "UED - Creative Marketing",
    "UED - Escrow": "UED - Escrow",
    "UED - Quikr X": "UED - Quikr X",
    "UED – Emailers": "UED – Emailers",
    "UED – Mobile App": "UED – Mobile App",
    "VL Delivery": "VL Delivery",
    "Web Development": "Web Development",
  };
  this.locations = [
    "Ahmedabad",
    "Bangalore",
    "Chandigarh",
    "Chennai",
    "Coimbatore",
    "Delhi",
    "Dwarka",
    "Gurgaon",
    "Hyderabad",
    "Kolkata",
    "Mumbai",
    "Noida",
    "Pune",
    "Rajasthan",
    "Jaipur",
    "Kochi",
    "Vadodara",
    "Raipur",
    "Lucknow",
    "Nagpur",
    "Vijaywada",
    "Goa",
    "Mangalore",
    "Indore",
    "Calicut",
    "Cochin",
  ];
  this.officeLocations = [
    "Delhi-Office",
    "WH-Khasra",
    "AtHomeDiva-Dwarka",
    "Athomediva-PaschimVihar",
    "Malviya Nagar",
    "Ahmedabad-Office",
    "Gurgaon-Office",
    "AtHomeDiva-DLF",
    "Manyata",
    "WH-Whitefield",
    "AtHomeDiva-HSR",
    "AtHomeDiva-Sanjaynagar",
    "BikePoint-Bangalore",
    "AtHomeDiva-Domlur",
    "AtHomeDiva-Marthahalli",
    "Kochi-Office",
    "EcoSpace",
    "WH-Chandivali",
    "Pune-Office",
    "WH-Kharadi",
    "At Home Diva-Andheri East",
    "Athomediva-Baner",
    "AtHomeDiva-Andheri West",
    "BikePoint",
    "Athomediva-Thane",
    "Chennai-Office",
    "AthomeDiva-Adyar",
    "At home Diva-T Nagar",
    "Hyderabad-Office",
    "WH-Kukatpally",
    "AtHomeDiva-Begumpet",
    "AtHomeDiva-Madhapur",
    "Bikepoint-Secunderabad",
    "Noida-Office",
    "Bike Point-Kormangala",
    "Gurgaon-Bike Point",
    "Bike Point- Noida",
    "Lucknow-Office",
    "Jaipur-Office",
    "AHD-Mumbai",
    "Bikepoint-Hinjawadi",
    "Bike Point-Kolkata",
    "Coimbatore-Office",
    "Bike Point-Nagpur",
    "BikePoint-Vadodara",
    "Kalina",
  ];
  this.verticals = [
    "Cars and Bikes",
    "Core",
    "Goods",
    "Jobs",
    "New Jobs",
    "QHMR",
    "QuikrRealty",
    "Real Estate",
    "Services",
    "Other Verticals",
  ];
  this.subDepartments = [
    "1800 Miss Call",
    "Account Management",
    "Activation",
    "Ad - Ops",
    "Ad Sales",
    "Admin",
    "AD_Posting",
    "Analytics",
    "Android",
    "Android- Escrow",
    "Audit & Geo Spatial",
    "Backend",
    "Bike Calling",
    "Bike_Procurement",
    "Bike_Selling",
    "Blogs & Articles",
    "Brand Marketing",
    "Business Intelligence",
    "Business Tools",
    "Caller",
    "Car Inspection",
    "Car Verified Leads",
    "CF",
    "CF Verification",
    "Channel Partner",
    "Chat",
    "Content",
    "Content Moderation",
    "Content Review",
    "Coordination Team",
    "Corporate Sales",
    "Customer Acquisiton Team",
    "Customer Operations",
    "Customer Service",
    "Customer Support",
    "Customer Support - TL",
    "Data Collection",
    "Data Entry",
    "Data Mining",
    "Delivery Ops",
    "Design",
    "Digital Marketing",
    "Digital Marketing - SEO",
    "Direct Sales",
    "Doorstep",
    "Email",
    "Email Support",
    "Employee Contracts",
    "Engagement Management",
    "Escrow",
    "Executive Assistant",
    "Finance and Accounts",
    "Forum",
    "FOS",
    "Frontend",
    "Full Stack",
    "Goods",
    "Google Adwords",
    "Graphics & Visuals",
    "Groups",
    "Head Count",
    "HomeVision",
    "Horizontal",
    "HR Operations",
    "HRBP",
    "HRMS",
    "Human Resource",
    "Inbound CC Team",
    "Inspection Calling",
    "Inspection monitization",
    "IOS",
    "IRX",
    "IRX Live",
    "IS",
    "IT",
    "IT Infra",
    "Jobs/Profile creation",
    "Jobs/Recruitment",
    "Lead Audit",
    "Lead Delivery",
    "Lead Gen",
    "Lead Generation",
    "Leads Delivery",
    "Logistics",
    "Market Research",
    "Marketing",
    "MGMT",
    "MIS",
    "Monetization",
    "Monetization/Escrow",
    "New Launch",
    "OBD_Services",
    "OMS",
    "OMS Horizontal",
    "On-Demand Services",
    "Operations",
    "Operations Hiring",
    "Payment",
    "Payments",
    "PCS",
    "PCS - Email Support - Leads",
    "PCS - Email Support - Listing",
    "PCS - Inbound",
    "PCS - Outbound - Leads",
    "PCS - Outbound - Listing",
    "PCS - Renewals",
    "PCS - Sales Helpdesk (Leads)",
    "PKHD",
    "PKHD/HomeVision",
    "PLV",
    "Post AD Drop cailing",
    "Premium Support- Inbound",
    "Premium Support- Outbound",
    "Product",
    "Product Monetization",
    "Project Management",
    "Public Relations",
    "QA",
    "QA-CR",
    "QH",
    "QH Moderation",
    "Quality",
    "Quikr X",
    "Quikr X - TL",
    "Quikr.com",
    "QuikrX",
    "Quikr_Stepni",
    "RE calling",
    "Realty Redefined",
    "Regional HR",
    "Regional HR/Administration",
    "Renewal",
    "Renewals",
    "Replies",
    "Research",
    "Revisiting",
    "RTO Services",
    "Sales",
    "Sales Analytics",
    "Sales Hiring",
    "Sales Operations",
    "Sales Support",
    "Sales-RE",
    "Scheduling",
    "Scheduling / Payment",
    "SEM",
    "SEO",
    "Service Provider Operations",
    "Service Seeker Operations",
    "Services",
    "SFM",
    "SFM - Ad Posting",
    "SFM - Escalations",
    "SFM - RM",
    "SFM- Ad Posting",
    "Social",
    "Social Media Support",
    "Stylist",
    "Stylist Allocation Team",
    "Tech Hiring",
    "Tech Ops",
    "Technology",
    "Telephony",
    "Telesales",
    "Testing",
    "Trainer",
    "Training - Sales & Ops",
    "UED",
    "UED - Centralized Ideation",
    "UED - Content",
    "UED - Creative Marketing",
    "UED - Escrow",
    "UED - Quikr X",
    "UED – Emailers",
    "UED – Mobile App",
    "UI Development",
    "UI/UX Design",
    "Voice",
    "ZSH",
    "Builder Sales",
    "CEO",
    "Buisness Transaction Sales",
    "Individual",
    "Assisted Property - Sales",
    "Event Management",
    "Assisted Property - PSM",
    "Service Ops - BRT",
    "Training & Quality",
    "Development",
    "Quality Testing",
    "Agent",
    "Sedbm",
    "MIS & Analytics",
    "Online Marketing",
    "Mobile Application",
    "System Admin",
    "BHP  Developing",
    "Data Ware house",
    "Web Developing",
    "Insurance",
    "Appliances",
    "Catalogue",
    "CATEGORY - FURNITURE",
    "Channel sales",
    "Marketing - B2B",
    "Marketing - Design",
    "Mobile - operation",
    "Offline Sales -Operation",
    "Operations - Mobile",
    "Sourcing",
    "Supply",
    "Training",
    "Planning",
    "Mobile - Operations",
    "Offline Sales-Operations",
    "Field Sales",
  ];
  this.departments = [
    "1800 Miss Call",
    "3D Development",
    "Account Management",
    "Ad Monetisation",
    "Admin",
    "AD_Posting",
    "Analytics",
    "Application Development",
    "Bike Calling",
    "Bike_Process",
    "Bike_Procurement",
    "Bike_Selling",
    "Branch Sales",
    "Brand Marketing",
    "Business Intelligence",
    "Business Tools",
    "Caller",
    "Car Inspection",
    "Car Verified Leads",
    "Channel Partner",
    "Chat",
    "Client Onboarding",
    "Content Moderation",
    "Content Research",
    "Content Review",
    "Content Tools",
    "Corporate Sales",
    "Customer Service",
    "Customer Support",
    "Customer Support - TL",
    "Cutomer Service",
    "Data Entry",
    "Data Mining",
    "Delivery Ops",
    "Design",
    "Digital Marketing",
    "Digital Marketing - SEM",
    "Digital Marketing - SEO",
    "Direct Sales",
    "Email Support",
    "Engagement Management",
    "Executive Assistant",
    "Finance and Accounts",
    "FOS",
    "FOS - R2",
    "FOS - R3",
    "Goods",
    "Groups",
    "Hiring",
    "HR Operations",
    "HRBP",
    "Human Resource",
    "Implementation - R2",
    "Implementation - R3",
    "Inspection Calling",
    "Inspection monitization",
    "IRX",
    "IT",
    "IT Infra",
    "Lead Generation",
    "Listing Ops",
    "Logistics",
    "Marketing",
    "MGMT",
    "MIS",
    "Mobile Apps",
    "Mobile Development",
    "OBD_Services",
    "Office Boy",
    "OMS",
    "OMS Horizontal",
    "On-Demand Services",
    "Operations",
    "Payment",
    "PKHD/HomeVision",
    "PLV",
    "Post AD Drop cailing",
    "Product",
    "Product Monetization",
    "Project Management",
    "Project Ops",
    "Public Relations",
    "QA-CR",
    "Quality",
    "Quality Assurance",
    "QUIKR AD SALES",
    "Quikr X",
    "Quikr X - TL",
    "QuikrX",
    "Quikr_Stepni",
    "RE calling",
    "Regional HR",
    "Renewal",
    "Replies",
    "Retention",
    "RTO Services",
    "Sale",
    "Sales",
    "Sales Hiree",
    "Sales marketing",
    "Sales Operations",
    "Scheduling",
    "Scheduling / Payment",
    "Service Provider Coordination",
    "Service Provider Operations",
    "Service Seeker Operations",
    "SFM",
    "SFM & Scheduling",
    "SFM - Ad Posting",
    "SFM - Escalations",
    "SFM - RM",
    "SFM- Ad Posting",
    "Social Media",
    "Social Media Support",
    "Stylist",
    "Technology",
    "Tele Sales",
    "Tele sales service",
    "Telesales",
    "Testing",
    "Trainer",
    "UED",
    "UI/UX Design",
    "User Experience",
    "Web Development",
    "Builder Sales",
    "Assisted Property",
    "Service Operations",
    "CEO",
    "Propfinder Sales",
    "Direct Marketing",
    "Propfinder Operations",
    "Events",
    "Online Marketing Analytics",
    "Appliances",
    "Catalogue",
    "CATEGORY - FURNITURE",
    "Channel sales",
    "Marketing - B2B",
    "Marketing - Design",
    "Mobile - Operation",
    "Offline Sales -Operation",
    "Operations - Mobile",
    "Sourcing",
    "Supply",
    "Training",
    "HR",
    "Assured E&A",
    "Assured Furniture",
    "Field Sales",
  ];
  this.functions = [
    "Ad - Operations",
    "Admin",
    "Analytics",
    "Finance and Accounts",
    "Human Resource",
    "Marketing",
    "MGMT",
    "Operations",
    "Product",
    "Product Monetization",
    "Public Relations",
    "Sales",
    "Sales Operations",
    "Technology",
    "UED",
    "Legal",
    "BornGroup"
  ];
  this.erp_department = [
    "Ad Sales",
    "Admin",
    "Analytics",
    "Finance and Accounts",
    "Human Resource",
    "Legal",
    "Marketing",
    "MGMT",
    "Operations : Logistics",
    "Operations : Operations - Others",
    "Product",
    "Public Relations",
    "Sales : FOS",
    "Sales : Sales - Others",
    "Sales : Telesales",
    "Sales Operations",
    "Technology",
    "UED",
    "Verticalization",
  ];
  this.category = ["A", "B", "C"];
  this.personneltype = ["E", "C", "I"];
  this.payrolls = [
    "Quikr",
    "Tarmack",
    "Team Lease(GH)",
    "Team Lease",
    "Hiree",
    "StayGlad",
    "Yoma",
    "Consultant",
    "Realty Redefined",
    "HDFC Realty",
    "QHMR",
    "Babajobs",
    "Zimmber",
    "ZEFO",
    "WMS Outsourcing",
    "Watermelon",
    "SG Facility Service",
    "Shivganesh",
    "JWC SSOS",
    "Payroll SSOS",
    "JWA",
    "AASAAN",
    "TRIDENT",
    "Propfinder",
    "India Property",
    "IKYA",
  ];
  this.genders = ["Male", "Female"];
  this.sources = [
    "Direct",
    "Referrals",
    "Vendors",
    "Rehire",
    "Campus",
    "Quikr Jobs Portal",
    "Jobs Portal - LinkedIn",
    "Jobs Portal - Naukri",
    "Jobs Portal - Monster",
    "Jobs Portal - Shine",
    "Jobs Portal - Indeed"
  ];
  this.domains = [
    ".co.in",
    ".com",
    "commonfloor.com",
    "gozefo.com",
    "realtyredefined.com",
  ];
  this.assets = ["no assets", "laptop", "desktop", "mac"];
  this.hrbp = ["135 Amit Badkas"];
  this.defaultProfilePicture = ["/public/images/profile.png"];
  this.imageSize = 2000000;
  this.tejaUrl = "https://teja9.kuikr.com";
  this.lineOfBusiness = [
    "Services Classifieds",
    "AtHomeDiva",
    "Home Services",
    "Goods Classifieds",
    "Goods C2C",
    "Goods Assured",
    "Cars&Bikes Classifieds",
    "Cars Transactions",
    "Bikes Transactions",
    "Jobs Classifieds",
    "Jobs Flexi",
    "Real Estate Classifieds",
    "RR Digital Marketing",
    "Brokerage Transactions",
    "Events",
    "Quikr PG",
    "RR Software Sales",
    "Commonfloor Groups",
    "Core Classifieds",
    "Common Centre",
    "Corporate Central",
  ];
  this.revenueStream = [
    "Classifieds",
    "Managed Rentals",
    "Transactions",
    "Corporate Central",
    "NA",
  ];
  this.businessCategory = {
    "Home Services": ["NA", "Laundry", "Painting", "Home Services"],
    "Goods Classifieds": ["NA", "Mobiles", "Furniture", "Electronics"],
    "Goods C2C": ["NA", "Mobiles", "Furniture", "Electronics"],
    "Goods Assured": ["NA", "Mobiles", "Furniture", "Electronics"],
    "Cars Transactions": ["NA", "Cars Transactions", "Cars RTO"],
    "Bikes Transactions": ["NA", "Bike Transactions", "Bikes RTO"],
    "Brokerage Transactions": [
      "NA",
      "Residential",
      "Commercial",
      "Consulting&Valuation",
    ],
    Events: ["NA", "QH PKHD", "QH Events", "CF PKHD", "CF Events", "IP Events"],
    "Core Classifieds": ["NA", "Education", "Pets"],
    "Corporate Central": ["NA"],
    "Services Classifieds": ["NA"],
    AtHomeDiva: ["NA"],
    "Cars&Bikes Classifieds": ["NA"],
    "Jobs Classifieds": ["NA"],
    "Jobs Flexi": ["NA"],
    "Real Estate Classifieds": ["NA"],
    "RR Digital Marketing": ["NA"],
    "Quikr PG": ["NA"],
    "RR Software Sales": ["NA"],
    "Commonfloor Groups": ["NA"],
    "Common Centre": ["NA"],
  };
  this.vendorBank = [
    "Axis Bank",
    "HDFC Bank",
    "ICICI Bank",
    "IDBI Bank",
    "Syndicate Bank",
    "Andhra Bank",
    "State Bank of India",
    "YES Bank",
    "Kotak Mahindra Bank",
  ];
})();
export default constants;



/** WEBPACK FOOTER **
 ** ./src/classes/constants.js
 **/